import $ from "jquery"
import select2 from "select2"
import "select2/dist/css/select2.min.css"
import "select2-bootstrap-theme/dist/select2-bootstrap.min.css"

export default function () {
  $(".select2").select2({
    placeholder: "Select Any",
    theme: "bootstrap",
  }).on('change', (e) => {
    controller.emit('select2-changed', this)
  })

  $(".complete-checklist-select2").select2({
    placeholder: "Stage",
    allowClear: true,
    theme: "bootstrap"
  }).on('change', (e) => {
    controller.emit('select2-changed', this)
  })

  // $(".council-select2").select2({
  //   placeholder: "Council",
  //   allowClear: true,
  //   theme: "bootstrap"
  // }).on('change', (e) => {
  //   controller.emit('select2-changed', this)
  // })

  $(".certifier-select2").select2({
    placeholder: "Certifier",
    allowClear: true,
    theme: "bootstrap"
  }).on('change', (e) => {
    controller.emit('select2-changed', this)
  })

  $(".council-select2").select2({
    placeholder: "Council",
    allowClear: true,
    theme: "bootstrap"
  }).on('change', (e) => {
    controller.emit('select2-changed', this)
  })

  $(".status-select2").each(function () {
    const $el = $(this)
    $el.select2({
      placeholder: $el.data("select2Placeholder") || "Progress",
      allowClear: true,
      theme: "bootstrap"
    }).on('change', function () {
      controller.emit('select2-changed', this)
    })
  })

  $(".project-type-select2").select2({
    placeholder: "Type",
    allowClear: true,
    theme: "bootstrap"
  }).on('change', (e) => {
    controller.emit('select2-changed', this)
  })

  $(".inspector-select2").select2({
    placeholder: "Inspector",
    allowClear: true,
    theme: "bootstrap"
  }).on('change', (e) => {
    controller.emit('select2-changed', this)
  })

  $(".pending-review-select2").select2({
    placeholder: "Review Status",
    allowClear: true,
    theme: "bootstrap"
  }).on('change', (e) => {
    controller.emit('select2-changed', this)
  })

  $(".clients-select2").select2({
    placeholder: "",
    allowClear: true,
    multiple: true,
    theme: "bootstrap",
    tags: true,
    width: "resolve",
    minimumResultsForSearch: Infinity,
  }).on('change', (e) => {
    controller.emit('select2-changed', this)
  })

  $(".recipients-select").select2({
    placeholder: "",
    allowClear: true,
    multiple: true,
    theme: "bootstrap",
    tags: true,
    width: "resolve",
    minimumResultsForSearch: Infinity,
  }).on('change', (e) => {
    controller.emit('select2-changed', this)
  })
}
